import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom"
import {
    ACCESS_DENIED_ROUTE,
    ACTIVATE_ACCOUNT_ACTIVATION_CODE_DA_ROUTE,
    ACTIVATE_ACCOUNT_ACTIVATION_CODE_ROUTE,
    ACTIVATE_ACCOUNT_CREATE_PASSWORD_DA_ROUTE,
    ACTIVATE_ACCOUNT_CREATE_PASSWORD_ROUTE,
    ACTIVATE_ACCOUNT_DA_ROUTE,
    ACTIVATE_ACCOUNT_ROUTE,
    ACTIVATE_ACCOUNT_SELECT_COMPANY_DA_ROUTE,
    ACTIVATE_ACCOUNT_SELECT_COMPANY_ROUTE,
    ACTIVATION_CODE_ROUTE,
    AUTH_PASSWORD_ROUTE,
    COMPANY_ACCOUNTING_MEETING_SERVICE_ROUTE,
    COMPANY_ACCOUNTING_POS_ROUTE,
    COMPANY_ACCOUNTING_SUBSCRIPTIONS_ROUTE,
    COMPANY_ADMIN_ACCOUNT_ADMINS_ROUTE,
    COMPANY_ADMIN_ACCOUNT_GDPR_ROUTE,
    COMPANY_ADMIN_ACCOUNTING_BILL_RECEIVERS_ROUTE,
    COMPANY_ADMIN_DATA_IMPORT_ACCOUNT_NUMBERS_RESULT_ROUTE,
    COMPANY_ADMIN_DATA_IMPORT_ACCOUNT_NUMBERS_ROUTE,
    COMPANY_ADMIN_DATA_IMPORT_BILL_RECEIVERS_RESULT_ROUTE,
    COMPANY_ADMIN_DATA_IMPORT_BILL_RECEIVERS_ROUTE,
    COMPANY_ADMIN_DATA_IMPORT_ID_CARDS_RESULT_ROUTE,
    COMPANY_ADMIN_DATA_IMPORT_ID_CARDS_ROUTE,
    COMPANY_ADMIN_DATA_IMPORT_USERS_RESULT_ROUTE,
    COMPANY_ADMIN_DATA_IMPORT_USERS_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_ADMINS_CREATE_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_CREATE_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_EDIT_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_LOCATIONS_CREATE_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_LOCATIONS_EDIT_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_LOCATIONS_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_CREATE_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_EDIT_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_USERS_CREATE_ROUTE,
    COMPANY_ADMIN_ORGANIZATION_USERS_ROUTE,
    COMPANY_ADMIN_ROUTE,
    COMPANY_ADMIN_SETTINGS_CUSTOM_JOBS_ROUTE,
    COMPANY_REPORTS_ROUTE,
    COMPANY_ROUTE,
    CONFIRM_ACCOUNT_CHANGE_ROUTE,
    CONFIRM_ACCOUNT_EMAIL_ROUTE,
    CONFIRM_BOOKING_PUBLIC_ROUTE,
    CONTROL_KITCHEN_ROUTE,
    CREATE_PASSWORD_ROUTE,
    ERROR_ROUTE,
    FORGOT_PASSWORD_ROUTE,
    getAsRoute,
    ID_CARD_SIGNUP_ROUTE,
    INVITATION_ROUTE,
    LOGIN_ROUTE,
    MERCHANT_ACCOUNTING_CASH_REGISTER,
    MERCHANT_ACCOUNTING_CUSTOMER_BALANCE,
    MERCHANT_ACCOUNTING_CUSTOMERS,
    MERCHANT_ACCOUNTING_ORDERS,
    MERCHANT_ACCOUNTING_PRODUCT_SALES,
    MERCHANT_ACCOUNTING_ROUTE,
    MERCHANT_ACCOUNTING_SUBSCRIPTIONS,
    MERCHANT_ACCOUNTING_Z_REPORT,
    MERCHANT_ADMIN_CREATE_PRICE_LIST_ROUTE,
    MERCHANT_ADMIN_CREATE_ROUTE,
    MERCHANT_ADMIN_CREATE_SURVEY_ITEM,
    MERCHANT_ADMIN_EDIT_SURVEY_ITEM_ROUTE,
    MERCHANT_ADMIN_EXTRA_SERVICES_CREATE_ROUTE,
    MERCHANT_ADMIN_EXTRA_SERVICES_EDIT_ROUTE,
    MERCHANT_ADMIN_EXTRA_SERVICES_ROUTE,
    MERCHANT_ADMIN_MERCHANT_ACCOUNT_ROUTE,
    MERCHANT_ADMIN_OFFERS_ROUTE,
    MERCHANT_ADMIN_PAYMENT_LINK_CREATE_ROUTE,
    MERCHANT_ADMIN_PAYMENT_LINK_EDIT_ROUTE,
    MERCHANT_ADMIN_PAYMENT_LINKS_ROUTE,
    MERCHANT_ADMIN_PRICE_LISTS_ROUTE,
    MERCHANT_ADMIN_PRODUCTS_CREATE_ROUTE,
    MERCHANT_ADMIN_PRODUCTS_EDIT_ROUTE,
    MERCHANT_ADMIN_PRODUCTS_GROUP_CREATE_ROUTE,
    MERCHANT_ADMIN_PRODUCTS_GROUP_ROUTE,
    MERCHANT_ADMIN_PRODUCTS_GROUP_UPDATE_ROUTE,
    MERCHANT_ADMIN_PRODUCTS_LIST_ROUTE,
    MERCHANT_ADMIN_ROUTE,
    MERCHANT_ADMIN_ROUTE_DEVICES,
    MERCHANT_ADMIN_SETTINGS_CREATE_VAT_CODES_ROUTE,
    MERCHANT_ADMIN_SETTINGS_CUSTOM_JOBS_ROUTE,
    MERCHANT_ADMIN_SETTINGS_DELIVERY_LOCATION_CREATE_ROUTE,
    MERCHANT_ADMIN_SETTINGS_DELIVERY_LOCATION_UPDATE_ROUTE,
    MERCHANT_ADMIN_SETTINGS_DELIVERY_LOCATIONS_ROUTE,
    MERCHANT_ADMIN_SETTINGS_ID_CARDS_ROUTE,
    MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNT_CREATE_ROUTE,
    MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNT_UPDATE_ROUTE,
    MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNTS_ROUTE,
    MERCHANT_ADMIN_SETTINGS_UPDATE_VAT_CODES_ROUTE,
    MERCHANT_ADMIN_SETTINGS_VAT_CODES_ROUTE,
    MERCHANT_ADMIN_SHOPS_CUSTOMER_ACCESS_ROUTE,
    MERCHANT_ADMIN_SHOPS_LIST_CREATE_ROUTE,
    MERCHANT_ADMIN_SHOPS_LIST_EDIT_ROUTE,
    MERCHANT_ADMIN_SHOPS_LIST_ROUTE,
    MERCHANT_ADMIN_SURVEYS,
    MERCHANT_ADMIN_UPDATE_PRICE_LIST_ROUTE,
    MERCHANT_ADMIN_USERS_ROUTE,
    MERCHANT_CUSTOM_REPORTS_ROUTE,
    MERCHANT_NEWS_CREATE_NEWS_ITEM_ROUTE,
    MERCHANT_NEWS_EDIT_NEWS_ITEM_ROUTE,
    MERCHANT_NEWS_ROUTE,
    MERCHANT_PRODUCTION_MEETING_SERVICE_ROUTE,
    MERCHANT_PRODUCTION_PLANNING_ROUTE,
    MERCHANT_PRODUCTION_POS_PURCHASES_ROUTE,
    MERCHANT_PRODUCTION_TAKEAWAY_ROUTE,
    MERCHANT_QUICKPAY_CANCELED_ROUTE,
    MERCHANT_QUICKPAY_FINALIZED_ROUTE,
    MERCHANT_REPORTS_MENU_PLANNING_ROUTE,
    MERCHANT_REPORTS_ROUTE,
    MERCHANT_REPORTS_TAKEAWAY_SUCCESS_ROUTE,
    MERCHANT_ROUTE,
    MESSAGES_ROUTE,
    MESSAGES_ROUTE_CREATE_MESSAGE_ITEM,
    MESSAGES_ROUTE_EDIT_MESSAGE_ITEM,
    NEWS_SUB_ROUTE,
    OFFICE_MANAGER_ROUTE,
    ORDER_ROUTE,
    PROFILE_CHANGE_PASSWORD_SUB_ROUTE,
    PROFILE_SUB_ROUTE,
    PUBLIC_MEETING_ORDER_RECEIPT,
    PUBLIC_ORDER_RECEIPT,
    PUBLIC_PACKAGE_SLIP_RECEIPT,
    PUBLIC_QUICKPAY_CANCELED_ROUTE,
    PUBLIC_QUICKPAY_FINALIZED_ROUTE,
    PUBLIC_ROADMAP_SHARE_ROUTE,
    PUBLIC_SELF_SIGN_UP_DA,
    PUBLIC_SELF_SIGN_UP_EN,
    ROOT_ROUTE,
    SERVICE_CENTER_ADMIN_ACCOUNT_ADMINISTRATORS_CREATE_ROUTE,
    SERVICE_CENTER_ADMIN_ACCOUNT_ADMINISTRATORS_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_CREATE_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_EDIT_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_MANAGE_BOOKINGS_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_CARS_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_MOBILE_AV_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_ROOM_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_EDIT_CARS_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_EDIT_MOBILE_AV_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_EDIT_ROOM_ROUTE,
    SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE,
    SERVICE_CENTER_ADMIN_ROUTE,
    SERVICE_CENTER_MESSAGES_CREATE_ROUTE,
    SERVICE_CENTER_MESSAGES_EDIT_ROUTE,
    SERVICE_CENTER_MESSAGES_ROUTE,
    SERVICE_CENTER_REPORTS_CALENDAR_ROUTE,
    SERVICE_CENTER_REPORTS_GUESTS_ROUTE,
    SERVICE_CENTER_REPORTS_MEETING_SERVICE_ROUTE,
    SERVICE_CENTER_REPORTS_PROFILE_ROUTE,
    SERVICE_CENTER_REPORTS_ROUTE,
    SERVICE_CENTER_REPORTS_STATISTICS_ROUTE,
    SERVICE_CENTER_ROUTE,
    SETTINGS_SUB_ROUTE,
    SIGN_IN_WITH_OTP_ROUTE,
    SUPPLIER_ADMIN_ACCOUNT_COMPANY_ROUTE,
    SUPPLIER_ADMIN_ACCOUNT_GDPR_ROUTE,
    SUPPLIER_ADMIN_ACQUIRING_REPORTS_ACQUIRING_FEES_ROUTE,
    SUPPLIER_ADMIN_ACQUIRING_REPORTS_BALANCE_ROUTE,
    SUPPLIER_ADMIN_ACQUIRING_REPORTS_BANK_TRANSFERS_ROUTE,
    SUPPLIER_ADMIN_ACQUIRING_ROUTE,
    SUPPLIER_ADMIN_ADMINISTRATORS_CREATE_ROUTE,
    SUPPLIER_ADMIN_ADMINISTRATORS_ROUTE,
    SUPPLIER_ADMIN_CREATE_PRODUCT_NUMBERS_ROUTE,
    SUPPLIER_ADMIN_DEVICES_ROUTE,
    SUPPLIER_ADMIN_MERCHANT_ADMINISTRATORS_ROUTE,
    SUPPLIER_ADMIN_MERCHANTS_CREATE_ROUTE,
    SUPPLIER_ADMIN_MERCHANTS_EDIT_ROUTE,
    SUPPLIER_ADMIN_MERCHANTS_LIST_ROUTE,
    SUPPLIER_ADMIN_POS_SETTINGS_CREATE_TEMPLATE_ROUTE,
    SUPPLIER_ADMIN_POS_SETTINGS_EDIT_TEMPLATE_ROUTE,
    SUPPLIER_ADMIN_POS_SETTINGS_ROUTE,
    SUPPLIER_ADMIN_PRODUCT_NUMBERS_ROUTE,
    SUPPLIER_ADMIN_ROUTE,
    SUPPLIER_ADMIN_TERMS_AND_CONDITIONS_CREATE_ROUTE,
    SUPPLIER_ADMIN_TERMS_AND_CONDITIONS_EDIT_ROUTE,
    SUPPLIER_ADMIN_TERMS_AND_CONDITIONS_ROUTE,
    SUPPLIER_ADMIN_UPDATE_PRODUCT_NUMBERS_ROUTE,
    SUPPLIER_REPORTS_ACCOUNTING_CUSTOMER_SALES_ROUTE,
    SUPPLIER_REPORTS_ACCOUNTING_MEETING_SERVICE_ROUTE,
    SUPPLIER_REPORTS_ACCOUNTING_MERCHANT_SALES_ROUTE,
    SUPPLIER_REPORTS_ACCOUNTING_POS_ROUTE,
    SUPPLIER_REPORTS_ACCOUNTING_SUBSCRIPTIONS_ROUTE,
    SUPPLIER_REPORTS_ACCOUNTING_Z_REPORTS_ROUTE,
    SUPPLIER_REPORTS_MERCHANTS_ROUTE,
    SUPPLIER_REPORTS_ROUTE,
    SUPPLIER_ROUTE,
    SUPPORT_ADMIN_GDPR_ROUTE,
    SUPPORT_ADMIN_HEALTH_ADYEN_ROUTE,
    SUPPORT_ADMIN_HEALTH_DATABASE_HEALTH_ROUTE,
    SUPPORT_ADMIN_HEALTH_SCHEDULER_EDIT_ROUTE,
    SUPPORT_ADMIN_HEALTH_SCHEDULER_ROUTE,
    SUPPORT_ADMIN_HEALTH_SERVER_MEMORY_ROUTE,
    SUPPORT_ADMIN_INVOICING_BASIS_FOR_INVOICING_ROUTE,
    SUPPORT_ADMIN_ROUTE,
    SUPPORT_ENTITIES_CREATE_COMPANY_ROUTE,
    SUPPORT_ENTITIES_CREATE_SUPPLIER_ROUTE,
    SUPPORT_ENTITIES_ROUTE,
    SUPPORT_ENTITIES_UPDATE_COMPANY_ROUTE,
    SUPPORT_ENTITIES_UPDATE_SUPPLIER_ROUTE,
    SUPPORT_FEATURES_EDIT_ROUTE,
    SUPPORT_FEATURES_ROUTE,
    SUPPORT_REPORTS_ENTITIES_ROUTE,
    SUPPORT_REPORTS_MERCHANTS_ROUTE,
    SUPPORT_REPORTS_MESSAGES_EMAIL_ROUTE,
    SUPPORT_REPORTS_MESSAGES_SMS_ROUTE,
    SUPPORT_REPORTS_PRINTER_QUEUE,
    SUPPORT_REPORTS_ROUTE,
    SUPPORT_REPORTS_ROUTE_DEVICES,
    SUPPORT_REPORTS_ROUTE_ORDERS_MEETING_SERVICE_ROUTE,
    SUPPORT_REPORTS_ROUTE_ORDERS_POS_ROUTE,
    SUPPORT_REPORTS_ROUTE_ORDERS_SUBSCRIPTIONS_ROUTE,
    SUPPORT_REPORTS_SUPPLIERS_ROUTE,
    SUPPORT_ROUTE,
    SURVEY_ROUTE,
    TENANT_ACCOUNTING_MEETING_SERVICE_ROUTE,
    TENANT_ACCOUNTING_POS_ROUTE,
    TENANT_ACCOUNTING_SUBSCRIPTIONS_ROUTE,
    TENANT_ADMIN_ROUTE,
    TENANT_REPORTS_ROUTE,
    TENANT_USERS_CREATE_ADMIN_ROUTE,
    TENANT_USERS_CREATE_USER_ROUTE,
    TENANT_USERS_ROUTE,
    USER_NAME_ROUTE,
    USER_QUICKPAY_CANCELED_ROUTE,
    USER_QUICKPAY_FINALIZED_ROUTE,
    USER_REPORTS_ARCHIVE_ROUTE,
    USER_REPORTS_CALENDAR_ROUTE,
    USER_REPORTS_GOPAY_NEWS_ROUTE,
    USER_REPORTS_PROFILE_ROUTE,
    USER_REPORTS_ROUTE,
    USER_REPORTS_SETTINGS_BILL_RECEIVERS_EDIT_ROUTE,
    USER_REPORTS_SETTINGS_ROUTE,
    USER_REPORTS_SETTINGS_WALLETS_REFILL_ROUTE,
    USER_REPORTS_SETTINGS_WALLETS_ROUTE,
    USER_REPORTS_SETTINGS_WALLETS_STATUS_FAILED_ROUTE,
    USER_REPORTS_SETTINGS_WALLETS_STATUS_POLL_ROUTE,
    USER_REPORTS_SETTINGS_WALLETS_STATUS_SUCCESS_ROUTE,
    USER_REPORTS_TAKEAWAY_SUCCESS_ROUTE,
    USER_REPORTS_UPCOMING_ORDERS_PURCHASES_ROUTE,
    USER_ROUTE,
    VIEWS_MERCHANT_CONFERENCE_ROUTE,
    VIEWS_ROUTE,
} from "../../constants/routes"
import { ForgotPassword } from "../../modules/login/pages/ForgotPassword"
import { SignInWithActivationCode } from "../../modules/login/pages/SignInWithActivationCode"
import { CreatePassword } from "../../modules/login/pages/CreatePassword"
import { Authenticated } from "../../modules/security/components/Authenticated"
import { ControlKitchen } from "../../modules/merchant/merchant/pages/ControlKitchen"
import { ErrorPage } from "./pages/ErrorPage"
import { OfficeHome } from "../../modules/office/pages/OfficeHome"
import { MerchantReportsHome } from "../../modules/merchant/merchant/home/pages/MerchantReportsHome"
import { Root } from "../../modules/root/pages/Root"
import { AccessDeniedPage } from "../../modules/security/pages/AccessDenied"
import { RequireUserTypeLayout } from "../../modules/security/components/RequireUserType"
import { NotFoundPage } from "./pages/NotFoundPage"
import { Profile } from "../../modules/profile/pages/Profile"
import { ChangePassword } from "../../modules/profile/pages/ChangePassword"
import { Layout } from "../../shared/layouts/Layout"
import { NewsPage } from "../../modules/news/pages/NewsPage"
import { Purchases } from "../../modules/office/reports/purchases/pages/Purchases"
import { MeetingService } from "../../modules/office/meetingService/pages/MeetingService"
import { StartPageLayout } from "../../modules/login/StartPageLayout"
import { UserType } from "../../modules/login/loginTypes"
import { RouteErrorHandler } from "../../shared/components/errors/RouteErrorHandler"
import { CreateNews } from "../../modules/merchant/admin/news/pages/CreateNews"
import { UpdateNews } from "../../modules/merchant/admin/news/pages/UpdateNews"
import { Invitation } from "../../modules/login/pages/Invitation"
import { Settings } from "../../modules/settings/pages/Settings"
import { Survey } from "../../modules/merchant/admin/survey/pages/Survey"
import { MerchantNews } from "../../modules/merchant/admin/news/pages/MerchantNews"
import { MerchantHome } from "../../modules/merchant/merchant/pages/MerchantHome"
import { Planning } from "../../modules/merchant/merchant/production/pages/Planning"
import { PosPurchases } from "../../modules/merchant/merchant/production/pages/PosPurchases"
import { Takeaway } from "../../modules/merchant/merchant/production/pages/Takeaway"
import { ProductSales } from "../../modules/merchant/accounting/accounting/pages/ProductSales"
import { Orders } from "../../modules/merchant/accounting/accounting/pages/Orders"
import { Subscriptions } from "../../modules/merchant/accounting/accounting/pages/Subscriptions"
import { CashRegister } from "../../modules/merchant/accounting/accounting/pages/CashRegister"
import { Customers } from "../../modules/merchant/accounting/accounting/pages/Customers"
import { CustomerBalance } from "../../modules/merchant/accounting/accounting/pages/CustomerBalance"
import { Messages } from "../../modules/merchant/admin/messages/pages/Messages"
import { CreateMessage } from "../../modules/merchant/admin/messages/pages/CreateMessage"
import { UpdateMessage } from "../../modules/merchant/admin/messages/pages/UpdateMessage"
import { SupplierHome } from "../../modules/supplier/pages/SupplierHome"
import { SupplierReportsHome } from "../../modules/supplier/reporting/pages/SupplierReportsHome"
import { MerchantAccess } from "../../modules/supplier/reporting/merchants/pages/MerchantAccess"
import { NavLayout } from "../../shared/layouts/NavLayout"
import { SupplierReportNavItems } from "../../modules/supplier/reporting/components/SupplierReportNavItems"
import { MerchantReportNavItems } from "../../modules/merchant/merchant/components/MerchantReportNavItems"
import { Fragment } from "react"
import { MerchantAdminNavItems } from "../../modules/merchant/admin/components/MerchantAdminNavItems"
import { SupportHome } from "../../modules/support/reports/home/pages/SupportHome"
import { SupportReportsHome } from "../../modules/support/reports/pages/SupportReportsHome"
import { SupportAdminHome } from "../../modules/support/admin/pages/SupportAdminHome"
import { SupportMerchants } from "../../modules/support/reports/pages/SupportMerchants"
import { SupportReportNavItems } from "../../modules/support/reports/components/SupportReportNavItems"
import { SupportSuppliers } from "../../modules/support/reports/pages/SupportSuppliers"
import { TenantAdminHome } from "../../modules/office/admin/pages/TenantAdminHome"
import { TenantReportsHome } from "../../modules/office/reports/pages/TenantReportsHome"
import { TenantUsers } from "../../modules/office/admin/pages/TenantUsers"
import { TenantAdminNavItems } from "../../modules/office/admin/components/TenantAdminNavItems"
import { TenantReportNavItems } from "../../modules/office/reports/components/TenantReportNavItems"
import { CustomerAccessPage } from "../../modules/merchant/admin/customers/pages/CustomerAccess"
import { MerchantAdminHomePage } from "../../modules/merchant/admin/pages/MerchantAdminHome"
import { CreateOrEditTenantAdmin } from "../../modules/office/admin/organization/administrators/pages/CreateOrEditTenantAdmin"
import { CreateOrEditTenantUser } from "../../modules/office/admin/organization/users/pages/CreateOrEditTenantUser"
import { PriceLists } from "../../modules/merchant/admin/priceList/pages/PriceLists"
import { CreatePriceList } from "../../modules/merchant/admin/priceList/pages/CreatePriceList"
import { ProductGroupPage } from "../../modules/merchant/admin/productGroup/pages/ProductGroup"
import { SurveysList } from "../../modules/merchant/admin/surveysList/pages/SurveysList"
import { CreateSurvey } from "../../modules/merchant/admin/surveysList/pages/CreateSurvey"
import { EditSurvey } from "../../modules/merchant/admin/surveysList/pages/EditSurvey"
import { SupplierAdminNavItems } from "../../modules/supplier/admin/components/SupplierAdminNavItems"
import { SupplierAdminHomePage } from "../../modules/supplier/admin/pages/SupplierAdminHome"
import { CreateProductGroupPage } from "../../modules/merchant/admin/productGroup/pages/CreateProductGroup"
import { MerchantAdminDevices } from "../../modules/merchant/admin/merchantAdminDevices/pages/MerchantAdminDevices"
import { SupportAdminNavItems } from "../../modules/support/admin/components/SupportAdminNavItems"
import { SupportDevices } from "../../modules/support/admin/supportDevicesPage/pages/SupportDevicesPage"
import { SupplierAdminDevices } from "../../modules/supplier/admin/merchant/devices/pages/SupplierDevicesPage"
import { SupplierAcquiringAgreement } from "../../modules/supplier/admin/settings/posAcquirer/pages/SupplierAcquiringAgreement"
import { MerchantUsers } from "../../modules/merchant/admin/pages/MerchantUsers"
import { SupplierAdministrators } from "../../modules/supplier/admin/account/administrators/pages/SupplierAdministrators"
import { MerchantIdCards } from "../../modules/merchant/admin/idCards/pages/MerchantIdCards"
import { SupportEntities } from "../../modules/support/admin/entities/pages/SupportEntities"
import { CreateCompany } from "../../modules/support/admin/entities/company/pages/CreateCompany"
import { UpdateCompany } from "../../modules/support/admin/entities/company/pages/UpdateCompany"
import { TermsAndConditionsList } from "../../modules/supplier/admin/settings/termsAndConditions/pages/TermsAndConditionsList"
import { CreateTermsAndConditions } from "../../modules/supplier/admin/settings/termsAndConditions/pages/CreateTermsAndConditions"
import { EditTermsAndConditions } from "../../modules/supplier/admin/settings/termsAndConditions/pages/EditTermsAndConditions"
import { EditProductPage } from "../../modules/merchant/admin/products/pages/EditProduct"
import { CompanyHome } from "../../modules/company/pages/CompanyHome"
import { CompanyAdminHome } from "../../modules/company/admin/pages/CompanyAdminHome"
import { OrganizationUserGroups } from "../../modules/company/admin/organization/userGroups/pages/UserGroups"
import { CreateUserGroup } from "../../modules/company/admin/organization/userGroups/pages/CreateUserGroup"
import { EditUserGroup } from "../../modules/company/admin/organization/userGroups/pages/EditUserGroup"
import { OrganizationDepartments } from "../../modules/company/admin/organization/departments/pages/Departments"
import { EditDepartment } from "../../modules/company/admin/organization/departments/pages/EditDepartment"
import { CreateDepartment } from "../../modules/company/admin/organization/departments/pages/CreateDepartment"
import { CompanyReportsHome } from "../../modules/company/reports/home/pages/CompanyReportsHome"
import { CompanyMeetingService } from "../../modules/company/reports/accounting/meetingService/pages/CompanyMeetingService"
import { CompanySubscriptions } from "../../modules/company/reports/accounting/subscriptions/pages/CompanySubscriptions"
import { CompanyReportNavItems } from "../../modules/company/reports/components/CompanyReportNavItems"
import { CompanyAdminNavItems } from "../../modules/company/admin/components/CompanyAdminNavItems"
import { OrganizationLocations } from "../../modules/company/admin/organization/locations/pages/Locations"
import { EditLocation } from "../../modules/company/admin/organization/locations/pages/EditLocation"
import { CreateLocation } from "../../modules/company/admin/organization/locations/pages/CreateLocation"
import { SupplierMerchants } from "../../modules/supplier/admin/merchant/merchants/pages/SupplierMerchants"
import { SupplierMerchantCreate } from "../../modules/supplier/admin/merchant/merchants/pages/SupplierMerchantCreate"
import { SupplierMerchantEdit } from "../../modules/supplier/admin/merchant/merchants/pages/SupplierMerchantEdit"
import { PosOrders } from "../../modules/company/reports/accounting/pos/pages/PosOrders"
import { ConfirmAccountChange } from "../../modules/login/pages/ConfirmAccountChange"
import { Admins } from "../../modules/company/admin/account/administrators/pages/Admins"
import { Users } from "../../modules/company/admin/organization/users/pages/Users"
import { Products } from "../../modules/merchant/admin/products/pages/Products"
import { CreateProductPage } from "../../modules/merchant/admin/products/pages/CreateProduct"
import { Shops } from "../../modules/merchant/admin/shops/pages/Shops"
import { CreateShop } from "../../modules/merchant/admin/shops/pages/CreateShop"
import { EditShop } from "../../modules/merchant/admin/shops/pages/EditShop"
import { Offers } from "../../modules/merchant/admin/offers/pages/Offers"
import { CreateSupplier } from "../../modules/support/admin/entities/supplier/pages/CreateSupplier"
import { UpdateSupplier } from "../../modules/support/admin/entities/supplier/pages/UpdateSupplier"
import { EditPriceList } from "../../modules/merchant/admin/priceList/pages/EditPriceList"
import { SupportBasisForInvoicing } from "../../modules/support/admin/invoicing/pages/SupportBasisForInvoicing"
import { SupplierPosSettings } from "../../modules/supplier/admin/settings/posSettings/pages/SupplierPosSettings"
import { EditProductGroup } from "../../modules/merchant/admin/productGroup/pages/EditProductGroup"
import { EditTemplatePage } from "../../modules/supplier/admin/settings/posSettings/pages/EditTemplate"
import { CreateTemplatePage } from "../../modules/supplier/admin/settings/posSettings/pages/CreateTemplate"
import { MenuPlanning } from "../../modules/merchant/merchant/menuPlanning/pages/MenuPlanning"
import { OfficeManagerSubscriptions } from "../../modules/office/reports/subscriptions/pages/OfficeManagerSubscriptions"
import { UpdateMerchantAccount } from "../../modules/merchant/admin/account/merchantAccount/page/UpdateMerchantAccount"
import { BillReceivers } from "../../modules/company/admin/accounting/bill-receivers/pages/BillReceivers"
import { VatCodesList } from "../../modules/merchant/admin/vatCodes/pages/VatCodesList"
import { CreateVatCode } from "../../modules/merchant/admin/vatCodes/pages/CreateVatCode"
import { EditVatCode } from "../../modules/merchant/admin/vatCodes/pages/EditVatCode"
import { DeliveryLocations } from "../../modules/merchant/admin/deliveryLocations/pages/DeliveryLocations"
import { CreateDeliveryLocation } from "../../modules/merchant/admin/deliveryLocations/pages/CreateDeliveryLocation"
import { EditDeliveryLocation } from "../../modules/merchant/admin/deliveryLocations/pages/EditDeliveryLocation"
import { UpdateSupplierAccount } from "../../modules/supplier/admin/account/companyAccount/pages/UpdateSupplierAccount"
import { ProductNumbersList } from "../../modules/supplier/admin/erp/productNumbers/pages/ProductNumbersList"
import { CreateProductNumber } from "../../modules/supplier/admin/erp/productNumbers/pages/CreateProductNumber"
import { EditProductNumber } from "../../modules/supplier/admin/erp/productNumbers/pages/EditProductNumber"
import { SupplierMeetingService } from "../../modules/supplier/reporting/accounting/meetingService/pages/SupplierMeetingService"
import { SupplierSubscriptions } from "../../modules/supplier/reporting/accounting/subscriptions/pages/SupplierSubscriptions"
import { SupplierPOSOrders } from "../../modules/supplier/reporting/accounting/pos/pages/SupplierPOSOrders"
import { MessagesEmailList } from "../../modules/support/reports/messages/email/pages/MessagesEmailsList"
import { MessagesSMSList } from "../../modules/support/reports/messages/sms/pages/MessagesSMSList"
import { SupplierMerchantSales } from "../../modules/supplier/reporting/accounting/merchantSales/pages/MerchantSalesList"
import { SupplierCustomerSales } from "../../modules/supplier/reporting/accounting/customerSales/pages/CustomerSalesList"
import { PrinterQueueList } from "../../modules/support/reports/printerQueue/pages/PrinterQueueList"
import { OrdersPOSList } from "../../modules/support/reports/orders/pos/pages/OrdersPOSList"
import { SupplierGDPRFiles } from "../../modules/supplier/admin/account/gdpr/pages/SupplierGDPRFiles"
import { CompanyGDPRFilesList } from "../../modules/company/admin/account/gdpr/pages/GDPRList"
import { SupportSubscriptions } from "../../modules/support/reports/orders/subscriptions/pages/SupportSubscriptions"
import { SupportMeetingService } from "../../modules/support/reports/orders/meetingService/pages/SupportMeetingService"
import { CompanyIdCards } from "../../modules/company/admin/dataImport/idCards/pages/CompanyIdCards"
import { CompanyIdCardsImportResult } from "../../modules/company/admin/dataImport/idCards/pages/CompanyIdCardsImportResult"
import { CompanyAccountNumbers } from "../../modules/company/admin/dataImport/accountNumbers/pages/CompanyAccountNumbers"
import { CompanyAccountNumbersImportResult } from "../../modules/company/admin/dataImport/accountNumbers/pages/CompanyAccountNumbersImportResult"
import { CompanyImportUsers } from "../../modules/company/admin/dataImport/users/pages/CompanyImportUsers"
import { CompanyImportUsersResult } from "../../modules/company/admin/dataImport/users/pages/CompanyImportUsersResult"
import { CompanyImportBillReceivers } from "../../modules/company/admin/dataImport/bill-receivers/pages/CompanyImportBillReceivers"
import { CompanyImportBillReceiversResult } from "../../modules/company/admin/dataImport/bill-receivers/pages/CompanyImportBillReceiversResult"
import { Balance } from "../../modules/supplier/admin/reconciliation/pages/Balance"
import { AcquiringFees } from "../../modules/supplier/admin/reconciliation/pages/AcquiringFees"
import { BankTransfers } from "../../modules/supplier/admin/reconciliation/pages/BankTransfers"
import { PaymentLinks } from "../../modules/merchant/admin/paymentLinks/pages/PaymentLinks"
import { CreatePaymentLink } from "../../modules/merchant/admin/paymentLinks/pages/CreatePaymentLink"
import { EditPaymentLink } from "../../modules/merchant/admin/paymentLinks/pages/EditPaymentLink"
import { SalesAccounts } from "../../modules/merchant/admin/salesAccounts/pages/SalesAccounts"
import { CreateSalesAccount } from "../../modules/merchant/admin/salesAccounts/pages/CreateSalesAccount"
import { EditSalesAccount } from "../../modules/merchant/admin/salesAccounts/pages/EditSalesAccount"
import { Conference } from "../../modules/views/merchant/conference/pages/Conference"
import { LayoutWrapper } from "../../shared/layouts/LayoutWrapper"
import { MerchantAdministrators } from "../../modules/supplier/admin/merchant/administrators/pages/MerchantAdministrators"
import { ZReports as MerchantZReports } from "../../modules/merchant/accounting/accounting/zReport/pages/ZReports"
import { ZReports as SupplierZReports } from "../../modules/supplier/reporting/accounting/zReport/pages/ZReports"
import { MerchantCustomReports } from "../../modules/merchant/accounting/accounting/merchantCustomReports/pages/MerchantCustomReports"
import { SupportFeatures } from "../../modules/support/admin/features/pages/SupportFeatures"
import { EditFeature } from "../../modules/support/admin/features/pages/EditFeature"
import { ServerMemoryUsage } from "../../modules/support/admin/health/serveMemory/pages/ServerMemoryUsage"
import { SchedulerJobList } from "../../modules/support/admin/health/scheduler/pages/SchedulerJobList"
import { EditSchedulerJob } from "../../modules/support/admin/health/scheduler/pages/EditSchedulerJob"
import { DatabaseHealth } from "../../modules/support/admin/health/databaseHealth/pages/DatabaseHealth"
import { SupportAdyen } from "../../modules/support/admin/health/adyen/pages/SupportAdyen"
import { SupportGDPR } from "../../modules/support/admin/gdpr/pages/SupportGDPR"
import { UserHome } from "../../modules/nonAdminUser/pages/UserHome"
import { UserPurchases } from "../../modules/nonAdminUser/reports/upcomingOrders/purchases/pages/UserPurchases"
import { MerchantCustomJobs } from "../../modules/merchant/admin/settings/customJobs/pages/MerchantCustomJobs"
import { LoginLayout } from "../../modules/login/components/LoginLayout"
import { IdCardSignup } from "../../modules/login/pages/IdCardSignup"
import { CompanyCustomJobs } from "../../modules/company/admin/settings/customJobs/pages/CompanyCustomJobs"
import { MerchantAccountingNavItems } from "../../modules/merchant/accounting/components/MerchantAccountingNavItems"
import { MerchantAccountingHome } from "../../modules/merchant/accounting/pages/MerchantAccountingHome"
import { UserWalletsRefill } from "../../modules/nonAdminUser/reports/settings/wallets/refill/pages/UserWalletsRefill"
import { UserWallets } from "../../modules/nonAdminUser/reports/settings/wallets/wallets/pages/UserWallets"
import { NarrowNavLayout } from "../../shared/layouts/NarrowNavLayout"
import { UserReportsHome } from "../../modules/nonAdminUser/reports/home/pages/UserReportsHome"
import { ServiceCenterHome } from "../../modules/serviceCenter/pages/ServiceCenterHome"
import { ServiceCenterReportsHome } from "../../modules/serviceCenter/report/home/pages/ServiceCenterReportsHome"
import { ServiceCenterAdminHome } from "../../modules/serviceCenter/admin/home/pages/ServiceCenterAdminHome"
import { UserReportsCalendar } from "../../modules/nonAdminUser/reports/calendar/pages/UserReportsCalendar"
import { UserArchiveArchive } from "../../modules/nonAdminUser/reports/archive/pages/UserArchiveArchive"
import { UserProfile } from "../../modules/nonAdminUser/pages/UserProfile"
import { UserNews } from "../../modules/nonAdminUser/pages/UserNews"
import { UserSettings } from "../../modules/nonAdminUser/reports/settings/integrations/pages/UserSettings"
import { EditBillReceiverPage } from "../../modules/nonAdminUser/reports/settings/integrations/pages/EditBillReceiverPage"
import { userReportingNavItems } from "../../modules/nonAdminUser/reports/userReportingNavItems"
import { UserTopBar } from "../../modules/nonAdminUser/reports/components/UserTopBar"
import { serviceCenterReportingNavItems } from "../../modules/serviceCenter/report/serviceCenterReportingNavItems"
import { ServiceCenterTopBar } from "../../modules/serviceCenter/report/components/ServiceCenterTopBar"
import { ServiceCenterAdminResources } from "../../modules/serviceCenter/admin/organization/resources/pages/ServiceCenterAdminResources"
import { MerchantProductionMeetingService } from "../../modules/merchant/merchant/production/pages/MerchantProductionMeetingService"
import { ServiceCenterMeetingService } from "../../modules/serviceCenter/report/upcomingBookings/pages/ServiceCenterMeetingService"
import { ServiceCenterGuestList } from "../../modules/serviceCenter/report/guestList/pages/ServiceCenterGuestList"
import { ServiceCenterAccountAdmins } from "../../modules/serviceCenter/admin/account/administrators/pages/ServiceCenterAccountAdmins"
import { ServiceCenterAdminManageBookings } from "../../modules/serviceCenter/admin/organization/manageBookings/pages/ServiceCenterAdminManageBookings"
import { CreateRoom } from "../../modules/serviceCenter/admin/organization/resources/pages/room/CreateRoom"
import { EditRoom } from "../../modules/serviceCenter/admin/organization/resources/pages/room/EditRoom"
import { UserMeetingsReceipt } from "../../modules/nonAdminUser/reports/MeetingsReceipt/UserMeetingsReceipt"
import { OutlookCreateOrder } from "../../modules/order/pages/OutlookCreateOrder"
import { PublicLayout } from "../../modules/login/components/idCardSignup/PublicLayout"
import { ConfirmBooking } from "../../modules/public/confirmBooking/pages/ConfirmBooking"
import { SelfSignUp } from "../../modules/public/selfSignUp/pages/SelfSignUp"
import { AutoLogin } from "../../modules/login/components/AutoLogin/AutoLogin"
import { ServiceCenterStatistics } from "../../modules/serviceCenter/report/statistics/pages/ServiceCenterStatistics"
import { ServiceCenterCalendar } from "../../modules/serviceCenter/report/calendar/pages/ServiceCenterCalendar"
import { ServiceCenterDevices } from "../../modules/serviceCenter/admin/organization/devices/pages/ServiceCenterDevices"
import { ServiceCenterProfile } from "../../modules/serviceCenter/report/account/pages/ServiceCenterProfile"
import { SignInWithUserName } from "../../modules/login/components/SignInWithUserName"
import { SignInWithPassword } from "../../modules/login/components/SignInWithPassword"
import { SignInLayout } from "../../modules/login/components/SignInLayout"
import { UserWalletsRefillStatusPoll } from "../../modules/nonAdminUser/reports/settings/wallets/status/pages/UserWalletsRefillStatusPoll"
import { UserWalletsRefillStatusFailed } from "../../modules/nonAdminUser/reports/settings/wallets/status/pages/UserWalletsRefillStatusFailed"
import { UserWalletsRefillStatusSuccess } from "../../modules/nonAdminUser/reports/settings/wallets/status/pages/UserWalletsRefillStatusSuccess"
import { TakeawayPaymentPoll } from "../../modules/nonAdminUser/reports/takeaway/pages/TakeawayPaymentPoll"
import { TakeawayPaymentCanceled } from "../../modules/nonAdminUser/reports/takeaway/pages/TakeawayPaymentCanceled"
import { TakeawayPaymentSuccess } from "../../modules/nonAdminUser/reports/takeaway/pages/TakeawayPaymentSuccess"
import { SelectCompany } from "../../modules/login/pages/SelectCompany"
import { MobileMenu } from "../../shared/layouts/MobileMenu"
import { ServiceCenterAdminNavItems } from "../../modules/serviceCenter/admin/components/ServiceCenterAdminNavItems"
import { isMobile } from "../../shared/utils/isMobile"
import { CreateDevice } from "../../modules/office/admin/organization/administrators/pages/CreateDevice"
import { EditDevice } from "../../modules/office/admin/organization/administrators/pages/EditDevice"
import { CreateCars } from "../../modules/serviceCenter/admin/organization/resources/pages/cars/CreateCars"
import { EditCar } from "../../modules/serviceCenter/admin/organization/resources/pages/cars/EditCar"
import { CreateMobileAV } from "../../modules/serviceCenter/admin/organization/resources/pages/mobileAV/CreateMobileAV"
import { EditMobileAV } from "../../modules/serviceCenter/admin/organization/resources/pages/mobileAV/EditMobileAV"
import { ServiceCenterMessages } from "../../modules/serviceCenter/admin/messages/pages/ServiceCenterMessages"
import { ServiceCenterCreateMessage } from "../../modules/serviceCenter/admin/messages/pages/ServiceCenterCreateMessage"
import { ServiceCenterUpdateMessage } from "../../modules/serviceCenter/admin/messages/pages/ServiceCenterUpdateMessage"
import { OrderPackageSlip } from "../../modules/merchant/merchant/production/meetingService/components/OrderPackageSlip"
import { ExtraServices } from "../../modules/merchant/admin/extraServices/pages/ExtraServices"
import { CreateExtraServicePage } from "../../modules/merchant/admin/extraServices/pages/CreateExtraService"
import { EditExtraService } from "../../modules/merchant/admin/extraServices/pages/EditExtraService"
import { ReceiptDialog } from "../../modules/receipt/pages/ReceiptDialog"
import { PublicRoadmapPage } from "../../modules/public/roadmap/pages/PublicRoadmapPage"
import { ConfirmAccountEmail } from "../../modules/login/pages/ConfirmAccountEmail"
import { Logger } from "../../lib/logging"

// Get base from HTML base element in index.html - and thereby %PUBLIC_URL%
// This will adjust all routes for the subfolder the app is deployed to
const baseAttr = document.querySelector("base")?.getAttribute("href") ?? "/"

// NOTE: Need to remove trailing slash if we have a path
const basename = baseAttr.length > 1 && baseAttr.endsWith("/") ? baseAttr.substring(0, baseAttr.length - 1) : baseAttr

function getBaseName() {
    const logger = new Logger("router")
    const appName = "portal"
    const oldAppName = "gopay-manager"
    const pageName = "index.html"
    const path = document.location.pathname
    let baseName = ""

    if (appName && path.includes(appName)) {
        // Scenario 1: We are deployed to subfolder on server
        // IMPORTANT: React Router expects basename WITHOUT trailing slash.
        // With a trailing slash, `/portal` (no `/` at end) won't match and you'll get a blank page.
        baseName = `${path.split(appName)[0]}${appName}`
    } else if (path.includes(oldAppName)) {
        // Same but using old app name
        baseName = `${path.split(oldAppName)[0]}${oldAppName}`
    } else if (path.includes(pageName)) {
        // Scenario 2: We are running inside Cordova
        baseName = `${path.split(pageName)[0]}${pageName}`
    } else {
        // Scenario 3: We are running locally under vite dev server
        baseName = "/"
    }

    logger.info(
        `Computed router base name '${baseName}' [appName: '${appName}', oldAppName: ${oldAppName}, pageName: '${pageName}', document location pathname: '${document.location.pathname}']`,
    )
    return baseName
}

// We cannot introduce a component for this due to react-router rules
function getCommonRoutes(key: string) {
    return (
        <Fragment key={key}>
            <Route id={`${key}-profile`} path={PROFILE_SUB_ROUTE} element={<Profile />} />
            <Route
                id={`${key}-change-password`}
                path={PROFILE_CHANGE_PASSWORD_SUB_ROUTE}
                element={<ChangePassword />}
            />
            <Route id={`${key}-settings`} path={SETTINGS_SUB_ROUTE} element={<Settings />} />
            <Route id={`${key}-news`} path={NEWS_SUB_ROUTE} element={<NewsPage />} />
        </Fragment>
    )
}

export const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route path={ROOT_ROUTE} element={<Root />} />

            <Route path={LOGIN_ROUTE} element={<StartPageLayout />} />
            <Route path={PUBLIC_MEETING_ORDER_RECEIPT} element={<UserMeetingsReceipt />} />
            <Route path={PUBLIC_ORDER_RECEIPT} element={<ReceiptDialog isPublic hasClose={false} />} />
            <Route path={PUBLIC_QUICKPAY_FINALIZED_ROUTE} element={<TakeawayPaymentPoll isPublic />} />
            <Route path={PUBLIC_QUICKPAY_CANCELED_ROUTE} element={<TakeawayPaymentCanceled isPublic />} />

            <Route path={PUBLIC_PACKAGE_SLIP_RECEIPT} element={<OrderPackageSlip />} />
            <Route
                path={PUBLIC_ROADMAP_SHARE_ROUTE}
                element={<PublicLayout fullWidth />}
                errorElement={<RouteErrorHandler />}
            >
                <Route index element={<PublicRoadmapPage />} />
            </Route>
            <Route element={<LoginLayout />} errorElement={<RouteErrorHandler />}>
                <Route element={<ForgotPassword />} path={FORGOT_PASSWORD_ROUTE} />
                <Route element={<SignInWithActivationCode />} path={ACTIVATION_CODE_ROUTE} />
                <Route element={<CreatePassword />} path={CREATE_PASSWORD_ROUTE} />
            </Route>
            <Route element={<SignInLayout />} errorElement={<RouteErrorHandler />}>
                <Route element={<SignInWithUserName />} path={USER_NAME_ROUTE} />
                <Route element={<SignInWithPassword />} path={AUTH_PASSWORD_ROUTE} />
            </Route>
            <Route element={<AutoLogin />} path={SIGN_IN_WITH_OTP_ROUTE} />
            <Route path={ID_CARD_SIGNUP_ROUTE} element={<PublicLayout />} errorElement={<RouteErrorHandler />}>
                <Route index element={<IdCardSignup />} />
            </Route>

            <Route path={CONFIRM_BOOKING_PUBLIC_ROUTE} element={<PublicLayout />} errorElement={<RouteErrorHandler />}>
                <Route index element={<ConfirmBooking />} />
            </Route>

            <Route path={PUBLIC_SELF_SIGN_UP_EN} element={<PublicLayout />} errorElement={<RouteErrorHandler />}>
                <Route index element={<SelfSignUp />} />
            </Route>
            <Route path={PUBLIC_SELF_SIGN_UP_DA} element={<PublicLayout />} errorElement={<RouteErrorHandler />}>
                <Route index element={<SelfSignUp />} />
            </Route>

            <Route path={INVITATION_ROUTE} element={<PublicLayout />} errorElement={<RouteErrorHandler />}>
                <Route index element={<Invitation />} />
            </Route>

            <Route path={ACTIVATE_ACCOUNT_ROUTE} element={<PublicLayout />} errorElement={<RouteErrorHandler />}>
                <Route element={<ForgotPassword isDefault={false} />} path={ACTIVATE_ACCOUNT_ROUTE} />
                <Route
                    element={<SignInWithActivationCode isDefault={false} />}
                    path={ACTIVATE_ACCOUNT_ACTIVATION_CODE_ROUTE}
                />
                <Route element={<CreatePassword isDefault={false} />} path={ACTIVATE_ACCOUNT_CREATE_PASSWORD_ROUTE} />
                <Route element={<SelectCompany isDefault={false} />} path={ACTIVATE_ACCOUNT_SELECT_COMPANY_ROUTE} />
            </Route>

            <Route path={ACTIVATE_ACCOUNT_DA_ROUTE} element={<PublicLayout />} errorElement={<RouteErrorHandler />}>
                <Route element={<ForgotPassword isDefault={false} isActivateDa />} path={ACTIVATE_ACCOUNT_DA_ROUTE} />
                <Route
                    element={<SignInWithActivationCode isDefault={false} isActivateDa />}
                    path={ACTIVATE_ACCOUNT_ACTIVATION_CODE_DA_ROUTE}
                />
                <Route
                    element={<CreatePassword isDefault={false} />}
                    path={ACTIVATE_ACCOUNT_CREATE_PASSWORD_DA_ROUTE}
                />
                <Route
                    element={<SelectCompany isDefault={false} isActivateDa />}
                    path={ACTIVATE_ACCOUNT_SELECT_COMPANY_DA_ROUTE}
                />
            </Route>

            <Route path={CONFIRM_ACCOUNT_CHANGE_ROUTE} element={<ConfirmAccountChange />} />

            <Route
                element={
                    <Authenticated>
                        <LayoutWrapper />
                    </Authenticated>
                }
                errorElement={<RouteErrorHandler />}
            >
                <Route path={ORDER_ROUTE} handle={{ userTypeRoot: true }}>
                    <Route path={getAsRoute(ORDER_ROUTE, ORDER_ROUTE)} element={<OutlookCreateOrder />} />
                </Route>
            </Route>
            <Route
                element={
                    <Authenticated>
                        <LayoutWrapper />
                    </Authenticated>
                }
                errorElement={<RouteErrorHandler />}
            >
                <Route path={VIEWS_ROUTE} handle={{ userTypeRoot: true }}>
                    <Route path={getAsRoute(VIEWS_ROUTE, VIEWS_MERCHANT_CONFERENCE_ROUTE)} element={<Conference />} />
                </Route>
            </Route>

            <Route
                element={
                    <Authenticated>
                        <PublicLayout />
                    </Authenticated>
                }
                errorElement={<RouteErrorHandler />}
            >
                <Route path={CONFIRM_ACCOUNT_EMAIL_ROUTE}>
                    <Route index element={<ConfirmAccountEmail />} />
                </Route>
            </Route>

            <Route
                element={
                    <Authenticated>
                        <Layout />
                    </Authenticated>
                }
                errorElement={<RouteErrorHandler />}
            >
                <Route
                    path={OFFICE_MANAGER_ROUTE}
                    element={<RequireUserTypeLayout userType={[UserType.OFFICE_MANAGER, UserType.SUPPORT]} />}
                    handle={{ userTypeRoot: true }}
                >
                    <Route index element={<OfficeHome />} />

                    <Route
                        path={getAsRoute(OFFICE_MANAGER_ROUTE, TENANT_ADMIN_ROUTE)}
                        element={
                            <NavLayout>
                                {" "}
                                <TenantAdminNavItems />
                            </NavLayout>
                        }
                        handle={{ environmentRoot: true, isAdmin: true }}
                    >
                        <Route index element={<TenantAdminHome />} />
                        <Route path={getAsRoute(TENANT_ADMIN_ROUTE, TENANT_USERS_ROUTE)} element={<TenantUsers />} />
                        <Route
                            path={getAsRoute(TENANT_ADMIN_ROUTE, TENANT_USERS_CREATE_USER_ROUTE)}
                            element={<CreateOrEditTenantUser />}
                        />
                        <Route
                            path={getAsRoute(TENANT_ADMIN_ROUTE, TENANT_USERS_CREATE_ADMIN_ROUTE)}
                            element={<CreateOrEditTenantAdmin type={UserType.OFFICE_MANAGER} />}
                        />
                        <Route path={getAsRoute(TENANT_ADMIN_ROUTE, TENANT_USERS_ROUTE)} element={<TenantUsers />} />

                        {getCommonRoutes("tenant-admin")}
                    </Route>

                    <Route
                        path={getAsRoute(OFFICE_MANAGER_ROUTE, TENANT_REPORTS_ROUTE)}
                        element={
                            <NavLayout>
                                {" "}
                                <TenantReportNavItems />
                            </NavLayout>
                        }
                        handle={{ environmentRoot: true }}
                    >
                        <Route index element={<TenantReportsHome />} />
                        <Route
                            path={getAsRoute(TENANT_REPORTS_ROUTE, TENANT_ACCOUNTING_POS_ROUTE)}
                            element={<Purchases />}
                        />
                        <Route
                            path={getAsRoute(TENANT_REPORTS_ROUTE, TENANT_ACCOUNTING_MEETING_SERVICE_ROUTE)}
                            element={<MeetingService />}
                        />
                        <Route
                            path={getAsRoute(TENANT_REPORTS_ROUTE, TENANT_ACCOUNTING_SUBSCRIPTIONS_ROUTE)}
                            element={<OfficeManagerSubscriptions />}
                        />

                        {getCommonRoutes("office-report")}
                    </Route>
                </Route>

                <Route
                    path={MERCHANT_ROUTE}
                    element={
                        <RequireUserTypeLayout userType={[UserType.MERCHANT, UserType.SUPPLIER, UserType.SUPPORT]} />
                    }
                    handle={{ userTypeRoot: true }}
                >
                    <Route index element={<MerchantHome />} />

                    <Route
                        path={getAsRoute(MERCHANT_ROUTE, MERCHANT_ADMIN_ROUTE)}
                        element={
                            <NavLayout>
                                <MerchantAdminNavItems />
                            </NavLayout>
                        }
                        handle={{ environmentRoot: true, isAdmin: true }}
                    >
                        <Route index element={<MerchantAdminHomePage />} />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_NEWS_ROUTE)}
                            element={<MerchantNews />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_NEWS_CREATE_NEWS_ITEM_ROUTE)}
                            element={<CreateNews />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_NEWS_EDIT_NEWS_ITEM_ROUTE)}
                            element={<UpdateNews />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_SHOPS_CUSTOMER_ACCESS_ROUTE)}
                            element={<CustomerAccessPage />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_USERS_ROUTE)}
                            element={<MerchantUsers />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_CREATE_ROUTE)}
                            element={<CreateOrEditTenantAdmin type={UserType.MERCHANT} />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_PRICE_LISTS_ROUTE)}
                            element={<PriceLists />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_CREATE_PRICE_LIST_ROUTE)}
                            element={<CreatePriceList />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_UPDATE_PRICE_LIST_ROUTE)}
                            element={<EditPriceList />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_SETTINGS_VAT_CODES_ROUTE)}
                            element={<VatCodesList />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_SETTINGS_CREATE_VAT_CODES_ROUTE)}
                            element={<CreateVatCode />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_SETTINGS_UPDATE_VAT_CODES_ROUTE)}
                            element={<EditVatCode />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_PRODUCTS_GROUP_ROUTE)}
                            element={<ProductGroupPage />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_PRODUCTS_GROUP_CREATE_ROUTE)}
                            element={<CreateProductGroupPage />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_PRODUCTS_GROUP_UPDATE_ROUTE)}
                            element={<EditProductGroup />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_SURVEYS)}
                            element={<SurveysList />}
                        />

                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_ROUTE_DEVICES)}
                            element={<MerchantAdminDevices />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_CREATE_SURVEY_ITEM)}
                            element={<CreateSurvey />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_EDIT_SURVEY_ITEM_ROUTE)}
                            element={<EditSurvey />}
                        />
                        <Route path={getAsRoute(MERCHANT_ADMIN_ROUTE, MESSAGES_ROUTE)} element={<Messages />} />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MESSAGES_ROUTE_CREATE_MESSAGE_ITEM)}
                            element={<CreateMessage />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MESSAGES_ROUTE_EDIT_MESSAGE_ITEM)}
                            element={<UpdateMessage />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_PRODUCTS_LIST_ROUTE)}
                            element={<Products />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_EXTRA_SERVICES_ROUTE)}
                            element={<ExtraServices />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_EXTRA_SERVICES_CREATE_ROUTE)}
                            element={<CreateExtraServicePage />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_EXTRA_SERVICES_EDIT_ROUTE)}
                            element={<EditExtraService />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_PRODUCTS_CREATE_ROUTE)}
                            element={<CreateProductPage />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_PRODUCTS_EDIT_ROUTE)}
                            element={<EditProductPage />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_SHOPS_LIST_ROUTE)}
                            element={<Shops />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_SHOPS_LIST_CREATE_ROUTE)}
                            element={<CreateShop />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_SHOPS_LIST_EDIT_ROUTE)}
                            element={<EditShop />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_PAYMENT_LINKS_ROUTE)}
                            element={<PaymentLinks />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_PAYMENT_LINK_CREATE_ROUTE)}
                            element={<CreatePaymentLink />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_PAYMENT_LINK_EDIT_ROUTE)}
                            element={<EditPaymentLink />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_OFFERS_ROUTE)}
                            element={<Offers />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_SETTINGS_DELIVERY_LOCATIONS_ROUTE)}
                            element={<DeliveryLocations />}
                        />
                        <Route
                            path={getAsRoute(
                                MERCHANT_ADMIN_ROUTE,
                                MERCHANT_ADMIN_SETTINGS_DELIVERY_LOCATION_CREATE_ROUTE,
                            )}
                            element={<CreateDeliveryLocation />}
                        />
                        <Route
                            path={getAsRoute(
                                MERCHANT_ADMIN_ROUTE,
                                MERCHANT_ADMIN_SETTINGS_DELIVERY_LOCATION_UPDATE_ROUTE,
                            )}
                            element={<EditDeliveryLocation />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNTS_ROUTE)}
                            element={<SalesAccounts />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNT_CREATE_ROUTE)}
                            element={<CreateSalesAccount />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNT_UPDATE_ROUTE)}
                            element={<EditSalesAccount />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_MERCHANT_ACCOUNT_ROUTE)}
                            element={<UpdateMerchantAccount />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_SETTINGS_ID_CARDS_ROUTE)}
                            element={<MerchantIdCards />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ADMIN_ROUTE, MERCHANT_ADMIN_SETTINGS_CUSTOM_JOBS_ROUTE)}
                            element={<MerchantCustomJobs />}
                        />
                        {getCommonRoutes("merchant-admin")}
                    </Route>

                    <Route
                        path={getAsRoute(MERCHANT_ROUTE, MERCHANT_REPORTS_ROUTE)}
                        element={
                            <NavLayout>
                                <MerchantReportNavItems />
                            </NavLayout>
                        }
                        handle={{ environmentRoot: true }}
                    >
                        <Route index element={<MerchantReportsHome />} />
                        <Route
                            path={getAsRoute(MERCHANT_REPORTS_ROUTE, CONTROL_KITCHEN_ROUTE)}
                            element={<ControlKitchen />}
                        />
                        <Route path={getAsRoute(MERCHANT_REPORTS_ROUTE, SURVEY_ROUTE)} element={<Survey />} />
                        <Route
                            path={getAsRoute(MERCHANT_REPORTS_ROUTE, MERCHANT_PRODUCTION_PLANNING_ROUTE)}
                            element={<Planning />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_REPORTS_ROUTE, MERCHANT_PRODUCTION_MEETING_SERVICE_ROUTE)}
                            element={<MerchantProductionMeetingService />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_REPORTS_ROUTE, MERCHANT_PRODUCTION_POS_PURCHASES_ROUTE)}
                            element={<PosPurchases />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_REPORTS_ROUTE, MERCHANT_PRODUCTION_TAKEAWAY_ROUTE)}
                            element={<Takeaway />}
                        />

                        <Route
                            path={getAsRoute(MERCHANT_REPORTS_ROUTE, MERCHANT_REPORTS_MENU_PLANNING_ROUTE)}
                            element={<MenuPlanning />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_REPORTS_ROUTE, MERCHANT_REPORTS_TAKEAWAY_SUCCESS_ROUTE)}
                            element={<TakeawayPaymentSuccess />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_REPORTS_ROUTE, MERCHANT_QUICKPAY_FINALIZED_ROUTE)}
                            element={<TakeawayPaymentPoll />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_REPORTS_ROUTE, MERCHANT_QUICKPAY_CANCELED_ROUTE)}
                            element={<TakeawayPaymentCanceled />}
                        />

                        {getCommonRoutes("merchant-reports")}
                    </Route>
                    <Route
                        path={getAsRoute(MERCHANT_ROUTE, MERCHANT_ACCOUNTING_ROUTE)}
                        element={
                            <NavLayout>
                                <MerchantAccountingNavItems />
                            </NavLayout>
                        }
                        handle={{ environmentRoot: true, isAccounting: true }}
                    >
                        <Route index element={<MerchantAccountingHome />} />
                        <Route
                            path={getAsRoute(MERCHANT_ACCOUNTING_ROUTE, MERCHANT_ACCOUNTING_PRODUCT_SALES)}
                            element={<ProductSales />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ACCOUNTING_ROUTE, MERCHANT_ACCOUNTING_ORDERS)}
                            element={<Orders />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ACCOUNTING_ROUTE, MERCHANT_ACCOUNTING_SUBSCRIPTIONS)}
                            element={<Subscriptions />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ACCOUNTING_ROUTE, MERCHANT_ACCOUNTING_Z_REPORT)}
                            element={<MerchantZReports />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ACCOUNTING_ROUTE, MERCHANT_CUSTOM_REPORTS_ROUTE)}
                            element={<MerchantCustomReports />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ACCOUNTING_ROUTE, MERCHANT_ACCOUNTING_CASH_REGISTER)}
                            element={<CashRegister />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ACCOUNTING_ROUTE, MERCHANT_ACCOUNTING_CUSTOMERS)}
                            element={<Customers />}
                        />
                        <Route
                            path={getAsRoute(MERCHANT_ACCOUNTING_ROUTE, MERCHANT_ACCOUNTING_CUSTOMER_BALANCE)}
                            element={<CustomerBalance />}
                        />

                        {getCommonRoutes("merchant-accounting")}
                    </Route>
                </Route>

                <Route
                    path={SUPPLIER_ROUTE}
                    element={<RequireUserTypeLayout userType={[UserType.SUPPLIER, UserType.SUPPORT]} />}
                    handle={{ userTypeRoot: true }}
                >
                    <Route index element={<SupplierHome />} />

                    <Route
                        path={getAsRoute(SUPPLIER_ROUTE, SUPPLIER_REPORTS_ROUTE)}
                        element={
                            <NavLayout>
                                <SupplierReportNavItems />
                            </NavLayout>
                        }
                        handle={{ environmentRoot: true }}
                    >
                        <Route index element={<SupplierReportsHome />} />
                        <Route
                            path={getAsRoute(SUPPLIER_REPORTS_ROUTE, SUPPLIER_REPORTS_MERCHANTS_ROUTE)}
                            element={<MerchantAccess />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_REPORTS_ROUTE, SUPPLIER_REPORTS_ACCOUNTING_MEETING_SERVICE_ROUTE)}
                            element={<SupplierMeetingService />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_REPORTS_ROUTE, SUPPLIER_REPORTS_ACCOUNTING_POS_ROUTE)}
                            element={<SupplierPOSOrders />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_REPORTS_ROUTE, SUPPLIER_REPORTS_ACCOUNTING_SUBSCRIPTIONS_ROUTE)}
                            element={<SupplierSubscriptions />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_REPORTS_ROUTE, SUPPLIER_REPORTS_ACCOUNTING_Z_REPORTS_ROUTE)}
                            element={<SupplierZReports />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_REPORTS_ROUTE, SUPPLIER_REPORTS_ACCOUNTING_MERCHANT_SALES_ROUTE)}
                            element={<SupplierMerchantSales />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_REPORTS_ROUTE, SUPPLIER_REPORTS_ACCOUNTING_CUSTOMER_SALES_ROUTE)}
                            element={<SupplierCustomerSales />}
                        />

                        {getCommonRoutes("supplier-reports")}
                    </Route>

                    <Route
                        path={getAsRoute(SUPPLIER_ROUTE, SUPPLIER_ADMIN_ROUTE)}
                        element={
                            <NavLayout>
                                <SupplierAdminNavItems />
                            </NavLayout>
                        }
                        handle={{ environmentRoot: true, isAdmin: true }}
                    >
                        <Route index element={<SupplierAdminHomePage />} />
                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_ACQUIRING_ROUTE)}
                            element={<SupplierAcquiringAgreement />}
                        />
                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_ADMINISTRATORS_ROUTE)}
                            element={<SupplierAdministrators />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_TERMS_AND_CONDITIONS_ROUTE)}
                            element={<TermsAndConditionsList />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_TERMS_AND_CONDITIONS_CREATE_ROUTE)}
                            element={<CreateTermsAndConditions />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_TERMS_AND_CONDITIONS_EDIT_ROUTE)}
                            element={<EditTermsAndConditions />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_PRODUCT_NUMBERS_ROUTE)}
                            element={<ProductNumbersList />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_CREATE_PRODUCT_NUMBERS_ROUTE)}
                            element={<CreateProductNumber />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_UPDATE_PRODUCT_NUMBERS_ROUTE)}
                            element={<EditProductNumber />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_ADMINISTRATORS_CREATE_ROUTE)}
                            element={<CreateOrEditTenantAdmin type={UserType.SUPPLIER} />}
                        />
                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_MERCHANTS_LIST_ROUTE)}
                            element={<SupplierMerchants />}
                        />
                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_MERCHANTS_CREATE_ROUTE)}
                            element={<SupplierMerchantCreate />}
                        />
                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_MERCHANTS_EDIT_ROUTE)}
                            element={<SupplierMerchantEdit />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_DEVICES_ROUTE)}
                            element={<SupplierAdminDevices />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_MERCHANT_ADMINISTRATORS_ROUTE)}
                            element={<MerchantAdministrators />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_ACCOUNT_COMPANY_ROUTE)}
                            element={<UpdateSupplierAccount />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_ACCOUNT_GDPR_ROUTE)}
                            element={<SupplierGDPRFiles />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_POS_SETTINGS_ROUTE)}
                            element={<SupplierPosSettings />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_POS_SETTINGS_CREATE_TEMPLATE_ROUTE)}
                            element={<CreateTemplatePage />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_POS_SETTINGS_EDIT_TEMPLATE_ROUTE)}
                            element={<EditTemplatePage />}
                        />

                        <Route
                            path={getAsRoute(SUPPLIER_ADMIN_ROUTE, SUPPLIER_ADMIN_ACQUIRING_REPORTS_BALANCE_ROUTE)}
                            element={<Balance />}
                        />

                        <Route
                            path={getAsRoute(
                                SUPPLIER_ADMIN_ROUTE,
                                SUPPLIER_ADMIN_ACQUIRING_REPORTS_ACQUIRING_FEES_ROUTE,
                            )}
                            element={<AcquiringFees />}
                        />

                        <Route
                            path={getAsRoute(
                                SUPPLIER_ADMIN_ROUTE,
                                SUPPLIER_ADMIN_ACQUIRING_REPORTS_BANK_TRANSFERS_ROUTE,
                            )}
                            element={<BankTransfers />}
                        />

                        {getCommonRoutes("supplier-admin")}
                    </Route>
                </Route>

                <Route
                    path={SUPPORT_ROUTE}
                    element={<RequireUserTypeLayout userType={UserType.SUPPORT} />}
                    handle={{ userTypeRoot: true }}
                >
                    <Route index element={<SupportHome />} />

                    <Route
                        path={getAsRoute(SUPPORT_ROUTE, SUPPORT_REPORTS_ROUTE)}
                        element={
                            <NavLayout>
                                <SupportReportNavItems />
                            </NavLayout>
                        }
                        handle={{ environmentRoot: true }}
                    >
                        <Route index element={<SupportReportsHome />} />
                        <Route
                            path={getAsRoute(SUPPORT_REPORTS_ROUTE, SUPPORT_REPORTS_SUPPLIERS_ROUTE)}
                            element={<SupportSuppliers />}
                        />
                        <Route
                            path={getAsRoute(SUPPORT_REPORTS_ROUTE, SUPPORT_REPORTS_MERCHANTS_ROUTE)}
                            element={<SupportMerchants />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_REPORTS_ROUTE, SUPPORT_REPORTS_ROUTE_DEVICES)}
                            element={<SupportDevices />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_REPORTS_ROUTE, SUPPORT_REPORTS_ENTITIES_ROUTE)}
                            element={<SupportEntities readonly />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_REPORTS_ROUTE, SUPPORT_REPORTS_MESSAGES_EMAIL_ROUTE)}
                            element={<MessagesEmailList />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_REPORTS_ROUTE, SUPPORT_REPORTS_MESSAGES_SMS_ROUTE)}
                            element={<MessagesSMSList />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_REPORTS_ROUTE, SUPPORT_REPORTS_PRINTER_QUEUE)}
                            element={<PrinterQueueList />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_REPORTS_ROUTE, SUPPORT_REPORTS_ROUTE_ORDERS_POS_ROUTE)}
                            element={<OrdersPOSList />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_REPORTS_ROUTE, SUPPORT_REPORTS_ROUTE_ORDERS_SUBSCRIPTIONS_ROUTE)}
                            element={<SupportSubscriptions />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_REPORTS_ROUTE, SUPPORT_REPORTS_ROUTE_ORDERS_MEETING_SERVICE_ROUTE)}
                            element={<SupportMeetingService />}
                        />

                        {getCommonRoutes("support-reports")}
                    </Route>

                    <Route
                        path={getAsRoute(SUPPORT_ROUTE, SUPPORT_ADMIN_ROUTE)}
                        element={
                            <NavLayout>
                                <SupportAdminNavItems />
                            </NavLayout>
                        }
                        handle={{ environmentRoot: true, isAdmin: true }}
                    >
                        <Route index element={<SupportAdminHome />} />

                        <Route
                            path={getAsRoute(SUPPORT_ADMIN_ROUTE, SUPPORT_ENTITIES_ROUTE)}
                            element={<SupportEntities />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_ADMIN_ROUTE, SUPPORT_ENTITIES_CREATE_SUPPLIER_ROUTE)}
                            element={<CreateSupplier />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_ADMIN_ROUTE, SUPPORT_ENTITIES_UPDATE_SUPPLIER_ROUTE)}
                            element={<UpdateSupplier />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_ADMIN_ROUTE, SUPPORT_ENTITIES_CREATE_COMPANY_ROUTE)}
                            element={<CreateCompany />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_ADMIN_ROUTE, SUPPORT_ENTITIES_UPDATE_COMPANY_ROUTE)}
                            element={<UpdateCompany />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_ADMIN_ROUTE, SUPPORT_FEATURES_ROUTE)}
                            element={<SupportFeatures />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_ADMIN_ROUTE, SUPPORT_FEATURES_EDIT_ROUTE)}
                            element={<EditFeature />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_ADMIN_ROUTE, SUPPORT_ADMIN_INVOICING_BASIS_FOR_INVOICING_ROUTE)}
                            element={<SupportBasisForInvoicing />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_ADMIN_ROUTE, SUPPORT_ADMIN_HEALTH_SCHEDULER_ROUTE)}
                            element={<SchedulerJobList />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_ADMIN_ROUTE, SUPPORT_ADMIN_HEALTH_SCHEDULER_EDIT_ROUTE)}
                            element={<EditSchedulerJob />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_ADMIN_ROUTE, SUPPORT_ADMIN_HEALTH_DATABASE_HEALTH_ROUTE)}
                            element={<DatabaseHealth />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_ADMIN_ROUTE, SUPPORT_ADMIN_HEALTH_SERVER_MEMORY_ROUTE)}
                            element={<ServerMemoryUsage />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_ADMIN_ROUTE, SUPPORT_ADMIN_HEALTH_ADYEN_ROUTE)}
                            element={<SupportAdyen />}
                        />

                        <Route
                            path={getAsRoute(SUPPORT_ADMIN_ROUTE, SUPPORT_ADMIN_GDPR_ROUTE)}
                            element={<SupportGDPR />}
                        />

                        {getCommonRoutes("support-admin")}
                    </Route>
                </Route>
                <Route
                    path={COMPANY_ROUTE}
                    element={<RequireUserTypeLayout userType={[UserType.COMPANY, UserType.SUPPORT]} />}
                    handle={{ userTypeRoot: true }}
                >
                    <Route index element={<CompanyHome />} />

                    <Route
                        path={getAsRoute(COMPANY_ROUTE, COMPANY_REPORTS_ROUTE)}
                        element={
                            <NavLayout>
                                <CompanyReportNavItems />
                            </NavLayout>
                        }
                        handle={{ environmentRoot: true }}
                    >
                        <Route index element={<CompanyReportsHome />} />

                        <Route
                            path={getAsRoute(COMPANY_REPORTS_ROUTE, COMPANY_ACCOUNTING_MEETING_SERVICE_ROUTE)}
                            element={<CompanyMeetingService />}
                        />

                        <Route
                            path={getAsRoute(COMPANY_REPORTS_ROUTE, COMPANY_ACCOUNTING_SUBSCRIPTIONS_ROUTE)}
                            element={<CompanySubscriptions />}
                        />
                        <Route
                            path={getAsRoute(COMPANY_REPORTS_ROUTE, COMPANY_ACCOUNTING_POS_ROUTE)}
                            element={<PosOrders />}
                        />

                        {getCommonRoutes("company-reports")}
                    </Route>

                    <Route
                        path={getAsRoute(COMPANY_ROUTE, COMPANY_ADMIN_ROUTE)}
                        element={
                            <NavLayout>
                                <CompanyAdminNavItems />
                            </NavLayout>
                        }
                        handle={{ environmentRoot: true, isAdmin: true }}
                    >
                        <Route index element={<CompanyAdminHome />} />
                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_ORGANIZATION_USERS_ROUTE)}
                            element={<Users />}
                        />

                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_ORGANIZATION_USERS_CREATE_ROUTE)}
                            element={<CreateOrEditTenantUser />}
                        />
                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_ACCOUNT_ADMINS_ROUTE)}
                            element={<Admins />}
                        />

                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_ORGANIZATION_ADMINS_CREATE_ROUTE)}
                            element={<CreateOrEditTenantAdmin type={UserType.COMPANY} />}
                        />
                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_ACCOUNTING_BILL_RECEIVERS_ROUTE)}
                            element={<BillReceivers />}
                        />

                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_ORGANIZATION_LOCATIONS_ROUTE)}
                            element={<OrganizationLocations />}
                        />

                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_ORGANIZATION_LOCATIONS_CREATE_ROUTE)}
                            element={<CreateLocation />}
                        />

                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_ORGANIZATION_LOCATIONS_EDIT_ROUTE)}
                            element={<EditLocation />}
                        />

                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_ROUTE)}
                            element={<OrganizationDepartments />}
                        />

                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_CREATE_ROUTE)}
                            element={<CreateDepartment />}
                        />

                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_EDIT_ROUTE)}
                            element={<EditDepartment />}
                        />

                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_ACCOUNT_GDPR_ROUTE)}
                            element={<CompanyGDPRFilesList />}
                        />

                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_DATA_IMPORT_ID_CARDS_ROUTE)}
                            element={<CompanyIdCards />}
                        />
                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_DATA_IMPORT_ID_CARDS_RESULT_ROUTE)}
                            element={<CompanyIdCardsImportResult />}
                        />
                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_DATA_IMPORT_ACCOUNT_NUMBERS_ROUTE)}
                            element={<CompanyAccountNumbers />}
                        />
                        <Route
                            path={getAsRoute(
                                COMPANY_ADMIN_ROUTE,
                                COMPANY_ADMIN_DATA_IMPORT_ACCOUNT_NUMBERS_RESULT_ROUTE,
                            )}
                            element={<CompanyAccountNumbersImportResult />}
                        />

                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_DATA_IMPORT_USERS_ROUTE)}
                            element={<CompanyImportUsers />}
                        />
                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_DATA_IMPORT_USERS_RESULT_ROUTE)}
                            element={<CompanyImportUsersResult />}
                        />

                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_DATA_IMPORT_BILL_RECEIVERS_ROUTE)}
                            element={<CompanyImportBillReceivers />}
                        />
                        <Route
                            path={getAsRoute(
                                COMPANY_ADMIN_ROUTE,
                                COMPANY_ADMIN_DATA_IMPORT_BILL_RECEIVERS_RESULT_ROUTE,
                            )}
                            element={<CompanyImportBillReceiversResult />}
                        />

                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_ROUTE)}
                            element={<OrganizationUserGroups />}
                        />
                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_CREATE_ROUTE)}
                            element={<CreateUserGroup />}
                        />
                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_EDIT_ROUTE)}
                            element={<EditUserGroup />}
                        />

                        <Route
                            path={getAsRoute(COMPANY_ADMIN_ROUTE, COMPANY_ADMIN_SETTINGS_CUSTOM_JOBS_ROUTE)}
                            element={<CompanyCustomJobs />}
                        />

                        {getCommonRoutes("company-admin")}
                    </Route>
                </Route>

                <Route
                    path={USER_ROUTE}
                    element={<RequireUserTypeLayout userType={[UserType.USER, UserType.SUPPORT]} />}
                    handle={{ userTypeRoot: true }}
                >
                    <Route index element={<UserHome />} />

                    <Route
                        path={getAsRoute(USER_ROUTE, USER_REPORTS_ROUTE)}
                        element={
                            <NarrowNavLayout navItems={userReportingNavItems}>
                                <UserTopBar />
                            </NarrowNavLayout>
                        }
                        handle={{ environmentRoot: true }}
                    >
                        <Route index element={<UserReportsHome />} />

                        <Route
                            path={getAsRoute(USER_REPORTS_ROUTE, USER_REPORTS_UPCOMING_ORDERS_PURCHASES_ROUTE)}
                            element={<UserPurchases />}
                        />

                        <Route
                            path={getAsRoute(USER_REPORTS_ROUTE, USER_REPORTS_CALENDAR_ROUTE)}
                            element={<UserReportsCalendar />}
                        />

                        <Route
                            path={getAsRoute(USER_REPORTS_ROUTE, USER_REPORTS_PROFILE_ROUTE)}
                            element={<UserProfile />}
                        />

                        <Route
                            path={getAsRoute(USER_REPORTS_ROUTE, USER_REPORTS_ARCHIVE_ROUTE)}
                            element={<UserArchiveArchive />}
                        />

                        <Route
                            path={getAsRoute(USER_REPORTS_ROUTE, USER_REPORTS_GOPAY_NEWS_ROUTE)}
                            element={<UserNews />}
                        />

                        <Route
                            path={getAsRoute(USER_REPORTS_ROUTE, USER_REPORTS_SETTINGS_ROUTE)}
                            element={<UserSettings />}
                        />
                        <Route
                            path={getAsRoute(USER_REPORTS_ROUTE, USER_REPORTS_SETTINGS_BILL_RECEIVERS_EDIT_ROUTE)}
                            element={<EditBillReceiverPage />}
                        />

                        <Route
                            path={getAsRoute(USER_REPORTS_ROUTE, USER_REPORTS_SETTINGS_WALLETS_ROUTE)}
                            element={<UserWallets />}
                        />

                        <Route
                            path={getAsRoute(USER_REPORTS_ROUTE, USER_REPORTS_SETTINGS_WALLETS_REFILL_ROUTE)}
                            element={<UserWalletsRefill />}
                        />

                        <Route
                            path={getAsRoute(USER_REPORTS_ROUTE, USER_REPORTS_SETTINGS_WALLETS_STATUS_POLL_ROUTE)}
                            element={<UserWalletsRefillStatusPoll />}
                        />

                        <Route
                            path={getAsRoute(USER_REPORTS_ROUTE, USER_REPORTS_SETTINGS_WALLETS_STATUS_SUCCESS_ROUTE)}
                            element={<UserWalletsRefillStatusSuccess />}
                        />

                        <Route
                            path={getAsRoute(USER_REPORTS_ROUTE, USER_REPORTS_SETTINGS_WALLETS_STATUS_FAILED_ROUTE)}
                            element={<UserWalletsRefillStatusFailed />}
                        />
                        <Route
                            path={getAsRoute(USER_REPORTS_ROUTE, USER_REPORTS_TAKEAWAY_SUCCESS_ROUTE)}
                            element={<TakeawayPaymentSuccess />}
                        />
                        <Route
                            path={getAsRoute(USER_REPORTS_ROUTE, USER_QUICKPAY_FINALIZED_ROUTE)}
                            element={<TakeawayPaymentPoll />}
                        />
                        <Route
                            path={getAsRoute(USER_REPORTS_ROUTE, USER_QUICKPAY_CANCELED_ROUTE)}
                            element={<TakeawayPaymentCanceled />}
                        />
                        {getCommonRoutes("user-reports")}
                    </Route>
                </Route>

                <Route
                    path={SERVICE_CENTER_ROUTE}
                    element={<RequireUserTypeLayout userType={[UserType.SERVICE_CENTER, UserType.SUPPORT]} />}
                    handle={{ userTypeRoot: true }}
                >
                    <Route index element={<ServiceCenterHome />} />

                    <Route
                        path={getAsRoute(SERVICE_CENTER_ROUTE, SERVICE_CENTER_REPORTS_ROUTE)}
                        element={
                            <NarrowNavLayout navItems={serviceCenterReportingNavItems}>
                                <ServiceCenterTopBar />
                            </NarrowNavLayout>
                        }
                        handle={{ environmentRoot: true }}
                    >
                        <Route index element={<ServiceCenterReportsHome />} />

                        <Route
                            path={getAsRoute(
                                SERVICE_CENTER_REPORTS_ROUTE,
                                SERVICE_CENTER_REPORTS_MEETING_SERVICE_ROUTE,
                            )}
                            element={<ServiceCenterMeetingService />}
                        />

                        <Route
                            path={getAsRoute(SERVICE_CENTER_REPORTS_ROUTE, SERVICE_CENTER_REPORTS_GUESTS_ROUTE)}
                            element={<ServiceCenterGuestList />}
                        />

                        <Route
                            path={getAsRoute(SERVICE_CENTER_REPORTS_ROUTE, SERVICE_CENTER_REPORTS_CALENDAR_ROUTE)}
                            element={<ServiceCenterCalendar />}
                        />

                        <Route
                            path={getAsRoute(SERVICE_CENTER_REPORTS_ROUTE, SERVICE_CENTER_REPORTS_STATISTICS_ROUTE)}
                            element={<ServiceCenterStatistics />}
                        />

                        <Route
                            path={getAsRoute(SERVICE_CENTER_REPORTS_ROUTE, SERVICE_CENTER_REPORTS_PROFILE_ROUTE)}
                            element={<ServiceCenterProfile />}
                        />

                        {getCommonRoutes("service-center-reports")}
                    </Route>

                    <Route
                        path={getAsRoute(SERVICE_CENTER_ROUTE, SERVICE_CENTER_ADMIN_ROUTE)}
                        element={
                            isMobile ? (
                                <MobileMenu>
                                    <ServiceCenterAdminNavItems />
                                </MobileMenu>
                            ) : (
                                <NarrowNavLayout navItems={serviceCenterReportingNavItems}>
                                    <ServiceCenterTopBar />
                                </NarrowNavLayout>
                            )
                        }
                        handle={{ environmentRoot: true, isAdmin: true }}
                    >
                        <Route index element={<ServiceCenterAdminHome />} />

                        <Route
                            path={getAsRoute(
                                SERVICE_CENTER_ADMIN_ROUTE,
                                SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE,
                            )}
                            element={<ServiceCenterAdminResources />}
                        />

                        <Route
                            path={getAsRoute(
                                SERVICE_CENTER_ADMIN_ROUTE,
                                SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_ROUTE,
                            )}
                            element={<ServiceCenterDevices />}
                        />
                        <Route
                            path={getAsRoute(
                                SERVICE_CENTER_ADMIN_ROUTE,
                                SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_CREATE_ROUTE,
                            )}
                            element={<CreateDevice />}
                        />
                        <Route
                            path={getAsRoute(
                                SERVICE_CENTER_ADMIN_ROUTE,
                                SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_EDIT_ROUTE,
                            )}
                            element={<EditDevice />}
                        />
                        <Route
                            path={getAsRoute(
                                SERVICE_CENTER_ADMIN_ROUTE,
                                SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_ROOM_ROUTE,
                            )}
                            element={<CreateRoom />}
                        />

                        <Route
                            path={getAsRoute(
                                SERVICE_CENTER_ADMIN_ROUTE,
                                SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_EDIT_ROOM_ROUTE,
                            )}
                            element={<EditRoom />}
                        />

                        <Route
                            path={getAsRoute(
                                SERVICE_CENTER_ADMIN_ROUTE,
                                SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_CARS_ROUTE,
                            )}
                            element={<CreateCars />}
                        />

                        <Route
                            path={getAsRoute(
                                SERVICE_CENTER_ADMIN_ROUTE,
                                SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_EDIT_CARS_ROUTE,
                            )}
                            element={<EditCar />}
                        />

                        <Route
                            path={getAsRoute(
                                SERVICE_CENTER_ADMIN_ROUTE,
                                SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_MOBILE_AV_ROUTE,
                            )}
                            element={<CreateMobileAV />}
                        />

                        <Route
                            path={getAsRoute(
                                SERVICE_CENTER_ADMIN_ROUTE,
                                SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_EDIT_MOBILE_AV_ROUTE,
                            )}
                            element={<EditMobileAV />}
                        />

                        <Route
                            path={getAsRoute(
                                SERVICE_CENTER_ADMIN_ROUTE,
                                SERVICE_CENTER_ADMIN_ORGANIZATION_MANAGE_BOOKINGS_ROUTE,
                            )}
                            element={<ServiceCenterAdminManageBookings />}
                        />

                        <Route
                            path={getAsRoute(
                                SERVICE_CENTER_ADMIN_ROUTE,
                                SERVICE_CENTER_ADMIN_ACCOUNT_ADMINISTRATORS_ROUTE,
                            )}
                            element={<ServiceCenterAccountAdmins />}
                        />

                        <Route
                            path={getAsRoute(
                                SERVICE_CENTER_ADMIN_ROUTE,
                                SERVICE_CENTER_ADMIN_ACCOUNT_ADMINISTRATORS_CREATE_ROUTE,
                            )}
                            element={<CreateOrEditTenantAdmin type={UserType.SERVICE_CENTER} />}
                        />

                        <Route
                            path={getAsRoute(SERVICE_CENTER_ADMIN_ROUTE, SERVICE_CENTER_MESSAGES_ROUTE)}
                            element={<ServiceCenterMessages />}
                        />
                        <Route
                            path={getAsRoute(SERVICE_CENTER_ADMIN_ROUTE, SERVICE_CENTER_MESSAGES_CREATE_ROUTE)}
                            element={<ServiceCenterCreateMessage />}
                        />
                        <Route
                            path={getAsRoute(SERVICE_CENTER_ADMIN_ROUTE, SERVICE_CENTER_MESSAGES_EDIT_ROUTE)}
                            element={<ServiceCenterUpdateMessage />}
                        />

                        {getCommonRoutes("service-center-admin")}
                    </Route>
                </Route>
            </Route>

            <Route path={ACCESS_DENIED_ROUTE} element={<AccessDeniedPage />} />

            <Route path={ERROR_ROUTE} element={<ErrorPage />} />

            <Route path="*" element={<NotFoundPage />} />
        </>,
    ),
    {
        basename: getBaseName(),
    },
)
